import { css } from 'styled-components'

export const HoverHide = css`
  .hover {
    opacity: 0;
    visibility: hidden;
    position: absolute;
  }
  &:hover {
    .normal {
      display: none;
      opacity: 0;
      visibility: hidden;
      position: absolute;
    }
    .hover {
      display: block;
      opacity: 1;
      visibility: visible;
      position: relative;
    }
  }
`
export const multiLineTextEllipsis = (line: number) => {
  return css`
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: ${line};
    -webkit-box-orient: vertical;
  `
}

export const placeholder = (color: string) => {
  return css`
    ::-moz-placeholder {
      color: ${color};
      opacity: 1;
    }
    :-ms-input-placeholder {
      color: ${color};
    }
    ::-webkit-input-placeholder {
      color: ${color};
    }
  `
}

/*
 *  mobile element size transform from the design draft width
 */
export function mbSize(size: string | number) {
  if (typeof size === 'string') {
    if (size.includes('px')) {
      size = size.split('px')[0]
    }
    if (size.includes('em')) {
      size = +size.split('em')[0] * 16
    }
  }
  size = +size
  return ((1 / 750) * 100 * size).toFixed(3) + 'vw'
}

/*
 *  pc element size transform from the design draft width
 */
export function pcSize(size: string | number) {
  if (typeof size === 'string') {
    if (size.includes('px')) {
      size = size.split('px')[0]
    }
    if (size.includes('em')) {
      size = +size.split('em')[0] * 16
    }
  }
  size = +size
  return ((1 / 1920) * 100 * size).toFixed(3) + 'vw'
}
